import React, { useEffect, useState } from "react"
import Select from 'react-select';
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "../scss/policyDetails.scss";
import { format, parse } from "date-fns";
import {   REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_ENDPOINT, WRAPPER_SERVICE  } from "../urls";
import NoDataFound from "../utilsComponent/noDataFound";
import LoadingPage from "../reusableComponents/loader/loadingPage";
import FileUpload from "../utilsComponent/fileUpload";
import { axiosRequest, axiosWithoutToken } from "../service";
import { startClaimIntimationImageCoordinatesService,getClaimDocuments, getPerilList } from "./apiHelper";
import { animalList,KISAN_SATHI_ANIMAL_LIST, claimIntimatedByOptions, kisanSathiClaimIntimatedByOptions, relationshipOptions, KISAN_SATHI, SELF, BANK_EMPLOYEE, unitOptions, isValidDamageArea, NILGAI, prakrithi, sukrithi, updatedAnimalList, additionalQuestionPerils, REGEX, DATE_FORMAT, NEW_POLICIES_START_DATE } from "../consts";
import AsteriskSymbol from "../reusableComponents/AsteriskSymbol";
import { areAllAnswersFilled, isOtherIntimatorInfoMissing } from "../utilFunctions";


const CreateClaim = (props) => {
    const { raiseClaim, cropList, setShowRadioSearch, setOpenDropDown, setRaiseclaim, productID, roleDataCookie, setSelectedIndex, additionalQuestions} = props
    const [dateField, setDateField] = useState("")
    const [timeField, setTimeField] = useState("")
    const [addedFiles, setAddedFiles] = useState([])
    const [modalShow, setModalShow] = useState(false);
    const [claimID, setClaimID] = useState("")
    const [policyHistory, setPolicyHistory] = useState([])
    const [sortedCauseDate, setSortedCauseDate] = useState(false)
    const [sortedIntimatDate, setSortedIntimatDate] = useState(false)
    const [attachmentType, setAttachmentType] = useState("")
    const [claimDone, setClaimDone] = useState(false);
    const [validtype, setvalidtype] = useState(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska'])
    const [calamityNames, setCalamityNames] = useState([]);
    const [calamityLabel, setCalamityLabel] = useState("")
    const [policyDetailsOnProductName, setPolicyDetailsOnProductName] = useState(null)
    const [leavePageConfirmationModal, setLeavePageConfirmationModal] = useState(false)
    const [selectedAnimal, setSelectedAnimal] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [claimIntimatedBy, setClaimIntimatedBy] = useState(null);
    const [showRelationship, setShowRelationship] = useState(false);
    const [showClaimIntimatorName, setShowClaimIntimatorName] = useState(false)
    const [intimatorName, setIntimatorName] = useState("");
    const [relationship, setRelationship] = useState("");
    const ignoreFileKeys = ['PreRegRuleLog', 'PostRegRuleLog','Rejection Letter','CWP Letter', 'Rejection Letter', 'Payout Letter', 'rejection', 'repudiation', 'payment']; // there are system generated json files
    const [reportedDamageArea, setReportedDamageArea] = useState('');
    const [reportedDamageAreaUnits, setReportedDamageAreaUnits] = useState('');
    const [perilList, setPerilList] = useState([]);
    const [animalsList, setAnimalsList] = useState([]);
    const [showAdditionalQuestion, setShowAdditionalQuestions] = useState(false);
    const [showAffectedDaysField, setShowAffectedDaysField] = useState(false)
    const [additionalQA, setAdditionalQA] = useState([])
    const setAdditionalQAValue = (questionId, answer) => {
        setAdditionalQA(prevQA =>
            prevQA.map(item =>
                item.qid === questionId
                    ? { ...item, questionAnswer: answer }
                    : item
            )
        );
    };
    useEffect(()=>{
        getPerilList(raiseClaim.product_name, setPerilList, raiseClaim?.purchase_date)
    },[raiseClaim.product_name])
    useEffect(() => {
        let defaultQA = []
        if([prakrithi, sukrithi]?.includes(productID)) {
            defaultQA = additionalQuestions?.map(question => (
                {
                    qid: question.questionId,
                    questionAnswer: null,
                    createdBy: roleDataCookie?.userID
                }
            ))
        }
        setAdditionalQA(defaultQA)
    }, [])

    useEffect(()=>{
        if(!showAffectedDaysField) {
            setAdditionalQAValue(2, null)
        }

    }, [showAffectedDaysField])
    useEffect(() => {
        const handleBeforeUnload = (event) => {
          event.preventDefault();
          event.returnValue = '';
          setLeavePageConfirmationModal(true)
        };
    
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }, []);
    const defaultClaim = {
        policyNumber: raiseClaim.policy_number,
        policyCropID: raiseClaim.crop_id,
        policyCropName: raiseClaim.crop_name,
        policyPerilNames: raiseClaim.perils.join(","),
        policyStatus: raiseClaim.policy_status,
        policyStartDate: raiseClaim.policy_start_date,
        policyEndDate: raiseClaim.policy_end_Date,
        userID: String(roleDataCookie?.userID),
        policyFarmerID: raiseClaim.farmer_id,
        policyFarmerName: raiseClaim.customer_name,
        policymobilenumber: Number(raiseClaim.customer_mobile_number),
        policySurveyNumber: raiseClaim.survey_number,
        policyStateID: raiseClaim.policy_state_id,
        policyState: raiseClaim.policy_state_name,
        policyDistrict: raiseClaim.policy_district_name,
        policyMandal: raiseClaim.policy_mandal_name,
        policyTaluka: raiseClaim.taluka,
        policyVillage: raiseClaim.policy_village_name,
        policyPincode: raiseClaim.policy_pincode,
        policyBlock: raiseClaim.block,
        seasonName: raiseClaim.season_name,
        seasonYear: raiseClaim.season_year,
        policyBalanceSumInsured: raiseClaim.balance_sum_insured,
        policyReconciliationStatus: raiseClaim.reconciliation_status,
        policyPolygonId: raiseClaim.customer_polygon,
        policySowingDate: raiseClaim.sowing_date,
        policyAccountNumber: raiseClaim.account_number,
        policyIssuanceDate: raiseClaim.policy_issuance_date,
        cultivatedArea: raiseClaim.cultivated_area,
        policyDuration: raiseClaim.policy_duration,
        assignedTo: roleDataCookie?.userID,
        role: roleDataCookie?.roleName,
        claimHandler: roleDataCookie?.roleName == "CLAIMS_HANDLER" ? roleDataCookie?.userID : "",
        surveyor: "",
        qcExecutive: "",
        qcLead: "",
        claimAmtApprover: "",
        claimProductID: productID,
        claimType: "",
        claimChannelID: 1,
        claimPerilName: "",
        claimRiskID: 0,
        claimRiskName: "",
        claimDescriptionofLoss: "",
        claimDateAndTimeOfLoss: "",
        claimAlternateMobileNumber: "",
        claimAttachmentType: "",
        claimEstimatedAmount: 0,
        claimDocuments: [0],
        tranId:raiseClaim.tran_id,
        covers: raiseClaim?.covers,
        cropPatternType: raiseClaim?.crop_pattern_type?.[0] || "",
        purchasedDate: raiseClaim?.purchase_date ||""
    }
    
    const handleAreaChange = (e) => {
       const value = e.target.value;
        if (isValidDamageArea(value)) {
            setReportedDamageArea(value);
            setClaimRequestData(prev => ({
            ...prev,
            reportedDamageArea: value || null
            }));
        }
    };

    const handleUnitChange = (e) => {
        const value = e.target.value;
        setReportedDamageAreaUnits(value);
        setClaimRequestData(prev => ({
            ...prev,
            reportedDamageAreaUnits: value || null
        }));
    };

    const customStyles = {
        control: (base, state) => ({
            ...base,
            border: 'none',
            boxShadow: 'none',
            fontWeight: '500',
            borderBottom: '1px solid #D2D2E4',
            borderRadius: 0,
            width: '95%',
            '&:hover': {
                borderBottom: '1px solid #D2D2E4',
            },
            '& .ms-3__indicator-separator': {
                display: 'none', // Hide the vertical bar
            },
            '& .css-1u9des2-indicatorSeparator': {
                display: 'none', // Hide the vertical bar
            },
        }),
    };

    const [claimRequestData, setClaimRequestData] = useState(defaultClaim)

    useEffect(() => {
        getcalamityList()
        // getPolicyDataOnProductName()
    }, [])
    const hanldeDatechange = (date) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const dat1 = (date.getDate()).toString().padStart(2, '0')
            setDateField(`${year}-${month}-${dat1}`)
            timeField && timeHandler(timeField, `${year}-${month}-${dat1}`)
        }
    }
    const getPolicyDataOnProductName = () => {
        axiosWithoutToken().post(`${WRAPPER_SERVICE}/search`, {
            searchType: "1",
            product: raiseClaim.product_name,
            searchValue: raiseClaim.policy_number
        }).then(data => {
            data.data && setPolicyDetailsOnProductName(data.data[0])
        }).catch(error => {
            console.log(error)
        })
    }
    const getcalamityList = () => {
        setCalamityNames({toast, setCalamityNames})
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/searchByPolicy`, { "policyId": raiseClaim.policy_number }).then(data => {
            // toast.success("Claim Created Successfully.")
            setPolicyHistory(data.data);
        }).catch(error => {
            console.log(error)
            //toast.error("Something Went Wrong.")
        })
    }
    const onRaiseclaim = () => {
        // if(!checkTimeBetweenDates(raiseClaim.policy_start_date, raiseClaim.policy_end_Date, dateField + "T" + timeField + ":00")){
        //     toast.error("Date and Time of Loss Should be in between Policy Start and End Dates.")
        //     return
        // }
        if(claimRequestData.claimAttachmentType?.value && addedFiles.length === 0){
            toast.error("Please Upload Attachments.")
            return
        }
        setClaimDone(true)
        const payload = {
            ...claimRequestData,
            claimAttachmentType: claimRequestData.claimAttachmentType?.value || "",
            claimDateAndTimeOfLoss: dateField + "T" + timeField + ":00",
            claimDocuments: addedFiles.map(list => list.id),
            perilAnimalName:selectedAnimal?.value || "",
            claimIntimatedBy: claimIntimatedBy === SELF ? SELF : intimatorName || "",
            claimIntimatedRelationship:relationship || null,
            // reportedDamageArea: reportedDamageArea || null,// e.g., "100.00|sq.ft"
            // reportedDamageAreaUnits: reportedDamageAreaUnits || null,
            claimQuestions: [prakrithi, sukrithi]?.includes(productID) && additionalQuestionPerils.includes(claimRequestData.claimPerilName?.toLocaleLowerCase()) ? additionalQA : []
        }
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/generateClaim`, payload).then(async data => {
            setClaimID(data.data.claimNo);
            setClaimDone(false)
            const response=await getClaimDocuments(data.data.claimNo)
            const images =response.data?.filter((item)=>!ignoreFileKeys.includes(item.docType)).map(item => item.docName);
            // setRaiseclaim(null)
            setModalShow(true)
            await startClaimIntimationImageCoordinatesService(data?.data?.claimNo,images);
        }).catch(error => {
            console.log(error)
            toast.error("Something Went Wrong.")
            setClaimDone(false);
        })
    }

    const sortCauseDates = () => {
        let sortedDates = []
        if (sortedCauseDate) {
            sortedDates = policyHistory.sort(function (a, b) {
                return new Date(b.dateAndTimeOfLoss) - new Date(a.dateAndTimeOfLoss)
            });
            setSortedCauseDate(false)
        } else {
            sortedDates = policyHistory.sort(function (a, b) {
                return new Date(a.dateAndTimeOfLoss) - new Date(b.dateAndTimeOfLoss)
            });
            setSortedCauseDate(true)
        }
        setPolicyHistory([...sortedDates])
    }
    const sortIntimateDates = () => {
        let sortedDates = []
        if (sortedIntimatDate) {
            sortedDates = policyHistory.sort(function (a, b) {
                return new Date(b.claimOpenDate) - new Date(a.claimOpenDate)
            });
            setSortedIntimatDate(false)
        } else {
            sortedDates = policyHistory.sort(function (a, b) {
                return new Date(a.claimOpenDate) - new Date(b.claimOpenDate)
            });
            setSortedIntimatDate(true)
        }
        setPolicyHistory([...sortedDates])
    }
    const timeHandler = (time, date) => {
        let dateNewField = date ? date : dateField
        if (new Date().setHours(0, 0, 0, 0) == new Date(dateNewField).setHours(0, 0, 0, 0)) {
            var d = new Date(); // for now
            d.getHours(); // => 9
            d.getMinutes();
            let str1 = time
            let str2 = String(d.getHours() + ":" + d.getMinutes())
            str1 = str1.split(':');
            str2 = str2.split(':');

            const totalSeconds1 = Number(str1[0] * 3600 + str1[1] * 60);
            const totalSeconds2 = Number(str2[0] * 3600 + str2[1] * 60);
            if (totalSeconds1 > totalSeconds2) {
                toast.error("Date & Time of Peril Occurrence Can't be Future Date & Time.")
                setTimeField("")
            } else {
                setTimeField(time)
            }
        } else {
            setTimeField(time)
        }
        if(dateNewField && time) {
            const [hours, minutes] = time.split(":");
            const combinedDateTime = new Date(dateNewField);
            combinedDateTime.setHours(hours);
            combinedDateTime.setMinutes(minutes);
            const now = new Date();
            const diff = now- combinedDateTime;
            const threeDays = 3 * 24 * 60 * 60 * 1000;
            setShowAffectedDaysField(diff > threeDays);
        }

    }
    const isDisabled = isOtherIntimatorInfoMissing(claimIntimatedBy, intimatorName, relationship);

    useEffect (() => {
        let list = [];
        if(productID == KISAN_SATHI) {
            list = KISAN_SATHI_ANIMAL_LIST;
        } else if([prakrithi, sukrithi].includes(productID)) {
            if(raiseClaim?.purchase_date) {
                const purchase = new Date(raiseClaim?.purchase_date);
                const policyStart = new Date(NEW_POLICIES_START_DATE);
                if (purchase >= policyStart) {
                 list = [...updatedAnimalList, ...raiseClaim?.covers?.includes(NILGAI) ? [{label: NILGAI, value: NILGAI}] : []]
                 setAnimalsList(list)
                 return
                }
            }
            list = animalList;
        } else {
            list = animalList;
        }
        setAnimalsList(list)

    }, [raiseClaim?.covers])
    
    return (
        <section className="p-4">
            <h5>Policy Details</h5>
            <div>
                <div className="outer-boxPolicy h-auto pb-5">
                    <div className="inner-boxPolicy h-auto">
                        <div >
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy align1Policy">Policy Number</p>
                                    <div className="align1_dataPolicy">{raiseClaim.policy_number}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align1Policy align3Policy align-topPolicy">Farmer Name</p>
                                    <div className="align1_dataPolicy">{raiseClaim.customer_name}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align1Policy align3Policy align-topPolicy">Crop Name</p>
                                    <div className="align1_dataPolicy">{raiseClaim.crop_name ? raiseClaim.crop_name : "--"}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Mobile Number</p>
                                    <div className="align1_dataPolicy">{raiseClaim.customer_mobile_number}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Farmer ID</p>
                                    <div className="align1_dataPolicy">{raiseClaim.farmer_id}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Survey Number</p>
                                    <div className="align1_dataPolicy">{raiseClaim.survey_number}</div>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <p className="align2Policy">Address</p>
                                    <div className="align2_dataPolicy"> {raiseClaim.customer_address}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">State</p>
                                    <div className="align1_dataPolicy">{raiseClaim.policy_state_name}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">District</p>
                                    <div className="align1_dataPolicy">{raiseClaim.policy_district_name}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Mandal</p>
                                    <div className="align1_dataPolicy">{raiseClaim.policy_mandal_name}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Block</p>
                                    <div className="align1_dataPolicy">{raiseClaim.block}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Village</p>
                                    <div className="align1_dataPolicy">{raiseClaim.policy_village_name ? raiseClaim.policy_village_name : "--"}</div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                    <p className="align3Policy">Pin Code</p>
                                    <div className="align1_dataPolicy">{raiseClaim.policy_pincode ? raiseClaim.policy_pincode : "--"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="claim-historyPolicy">
                        <h3 id="new_claimPolicy" className="ms-4 mt-4">Claim History</h3>
                        {/* <h2 id="history"></h2> */}
                        {
                            policyHistory && policyHistory.length ? (
                                <div className="overflowPolicy mt-3">
                                    <table id="claim_historyPolicy">
                                        <thead>
                                            <tr>
                                                <th>Claim ID</th>
                                                <th>Cause of Loss</th>
                                                <th>
                                                    Date &amp; Time of Loss{" "}
                                                    <span className="pointerPolicy" onClick={() => sortCauseDates()}>
                                                        <img
                                                            src="../kshemaImages/Vector.png"
                                                            alt="dropdown vector"
                                                            width="auto"
                                                            height="8px"
                                                            className="pointer"
                                                        />
                                                    </span>
                                                </th>
                                                <th className="pointerPolicy" onClick={() => sortIntimateDates()}>
                                                    Intimated Date &amp; time{" "}
                                                    <span>
                                                        <img
                                                            src="../kshemaImages/Vector.png"
                                                            alt="dropdown vector"
                                                            width="auto"
                                                            height="8px"
                                                            className="pointer"
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    Claim Amount{" "}
                                                    <span>
                                                        <img
                                                            src="../kshemaImages/Vector.png"
                                                            alt="dropdown vector"
                                                            width="auto"
                                                            height="8px"
                                                        />
                                                    </span>
                                                </th>
                                                <th>Sub Status</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                policyHistory && policyHistory.map(list => {
                                                    return (
                                                        <tr>
                                                        <td className="claim_idPolicy">{list.claimNo}</td>
                                                        <td>{list.perilName}</td>
                                                        <td>{list?.dateAndTimeOfLoss ? format(new Date(list.dateAndTimeOfLoss.replace(" ","T").split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "--"}</td>
                                                        <td>{list?.claimOpenDate ? format(new Date(list.claimOpenDate.replace(" ","T").split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "--"}</td>
                                                        <td>{list?.estimatedAmount ? `₹${list?.estimatedAmount}` : "--"} </td>
                                                        <td className="registerPolicy">{list?.claimSubstatus ? list?.claimSubstatus : "--"}</td>
                                                        <td className="registerPolicy">{list?.claimStatus ? list?.claimStatus : "--"}</td>
                                                    </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <NoDataFound text={"No data Found"} />
                            )
                        }
                    </div>
                    <div className="inner-box2Policy h-auto mb-2">
                        <h3 id="new_claimPolicy">New Claim Details</h3>
                        {claimDone ? <LoadingPage claimDone={claimDone} /> : null}
                        <div>
                            <div className="row mt-5">
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                    <p className="align3Policy">
                                        Peril Type <AsteriskSymbol/>
                                    </p>
                                    <Select id="exampleInputPassword3" className="ms-3" classNamePrefix="ms-3" options={perilList}
                                        // isDisabled={!claimRequestData.product_name}
                                        value={claimRequestData.claimPerilName ? { label: claimRequestData.claimPerilName, value: claimRequestData.claimPerilName } : { label: "Select Peril", value: "Select Peril" }}
                                        onChange={(data) => { setClaimRequestData({ ...claimRequestData, 'claimPerilName': data.label, animalName:""})
                                        setSelectedAnimal("");
                                        if(data?.label && additionalQuestionPerils.includes(data?.label?.toLocaleLowerCase()) && [prakrithi, sukrithi]?.includes(productID)) {
                                            setShowAdditionalQuestions(true);                    
                                        } else {
                                            setShowAdditionalQuestions(false)
                                        }
                                    }}
                                        styles={customStyles}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                    <p className="align3Policy ms-0">Crop Name <AsteriskSymbol/></p>
                                    <Select
                                        id="exampleInputPassword2"
                                        options={cropList}
                                        value={claimRequestData.claimRiskName ? { label: claimRequestData.claimRiskName, value: claimRequestData.claimRiskID } : { label: "Select Crop Name", value: "Select Crop Name" }}
                                        onChange={(data) => { setClaimRequestData({ ...claimRequestData, claimRiskName: data.label, claimRiskID: Number(data.value) }) }}
                                        styles={customStyles}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12" style={{ marginTop: "1px" }}>
                                    <p className="align3Policy">Alternate Contact Number</p>
                                    <input
                                        type="tel"
                                        className="align3_dataPolicy mt-3"
                                        name="tel"
                                        id="tel"
                                        placeholder="Enter Alternate Contact Number"
                                        maxLength={10}
                                        onChange={(e) => {
                                            //const numericValue = e.target.value.replace(/[A-Za-z]/g, '');
                                            const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                            e.target.value = numericValue;
                                            setClaimRequestData({ ...claimRequestData, 'claimAlternateMobileNumber': e.target.value })
                                        }
                                        }
                                    />
                                </div>
                                {claimRequestData.claimPerilName === "Animal Attack" && (
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="align3Policy">Animal Name <AsteriskSymbol/></p>
                                        <Select
                                            id="animalName"
                                            className="ms-3"
                                            classNamePrefix="ms-3"
                                            options={animalsList}
                                            value={selectedAnimal ? selectedAnimal : {label : "Select Animal Name",value : "Select Animal Name"}}
                                            onChange={(selectedOption) => {
                                                if (selectedOption.value === "Nilgai") {
                                                    setShowConfirmation(true);
                                                } else {
                                                    setSelectedAnimal(selectedOption);
                                                }
                                            }}
                                            styles={customStyles}
                                        />

                                        {showConfirmation && (
                                            <div className="custom-modal">
                                                <div className="custom-modal-content confirmation-modal">
                                                    <div className="custom-modal-body">
                                                        <p className="confirmation-text">Are you sure it is a Nilgai attack?
                                                        <span
                                                            onClick={() => setShowConfirmation(false)}
                                                            className="inline-close"
                                                        >
                                                            &times;
                                                        </span>
                                                        </p>
                                                    </div>
                                                    <div className="button-container">
                                                        <button
                                                            className="custom-btn custom-btn-secondary"
                                                            onClick={() => {
                                                                setSelectedAnimal({ value: "Nilgai", label: "Nilgai" });
                                                                setShowConfirmation(false);
                                                            }}
                                                        >
                                                            Yes
                                                        </button>
                                                        <button
                                                            className="custom-btn custom-btn-primary"
                                                            onClick={() => {
                                                                setSelectedAnimal(null);
                                                                setShowConfirmation(false);
                                                            }}
                                                        >
                                                            No
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                    <p className="align3Policy">Claim Intimated By <AsteriskSymbol/></p>
                                    <Select
                                        id="claimIntimatedBy"
                                        className="ms-3"
                                        classNamePrefix="ms-3"
                                        options={productID === KISAN_SATHI ? kisanSathiClaimIntimatedByOptions : claimIntimatedByOptions}
                                        styles={customStyles}
                                        value={claimIntimatedBy ? claimIntimatedBy?.value : {label : "Select Claim Intimated By", value : "Select Claim Intimated By"}}
                                        onChange={(selectedOption) => {
                                            setClaimIntimatedBy(selectedOption.value);
                                            setIntimatorName("");
                                            setRelationship("")
                                            if (selectedOption.value === SELF) {
                                                setShowRelationship(false);
                                                setShowClaimIntimatorName(false)
                                            } else if(selectedOption.value === BANK_EMPLOYEE) {
                                                setShowClaimIntimatorName(true);
                                                setShowRelationship(false);
                                            }else {
                                                setShowClaimIntimatorName(true);
                                                setShowRelationship(true);
                                            }
                                        }}
                                    />
                                </div>
                                 {showClaimIntimatorName && (
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 claim-intimator-container">
                                        {claimIntimatedBy === BANK_EMPLOYEE ? 
                                        <p className="align3Policy">Bank Employee Name <AsteriskSymbol/></p>
                                        :
                                        <p className="align3Policy">Claim Intimator Name <AsteriskSymbol/></p>
                                        }
                                        <input
                                            id="intimatorName"
                                            className="claim-intimator-textarea mt-2 ms-3"
                                            placeholder={claimIntimatedBy === BANK_EMPLOYEE ? "Enter Bank Employee Name": "Enter Claim Intimator Name"}
                                            value={intimatorName}
                                            maxLength={100}
                                            onChange={(e) => setIntimatorName(e.target.value)}
                                        />
                                    </div>
                                 )}
                                 {showRelationship && (
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="align3Policy">Relationship with Policyholder <AsteriskSymbol/></p>
                                        <Select
                                            id="relationship"
                                            className="ms-3"
                                            classNamePrefix="ms-3"
                                            options={relationshipOptions}
                                            value={relationship ? relationship ?.value : {label :"Select Relationship", value :"Select Relationship"}}
                                            styles={customStyles}
                                            onChange={(selectedOption) => setRelationship(selectedOption.value)}
                                            required
                                        />
                                    </div>
                                )}
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                    <p className="align6Policy">
                                        Date &amp; Time of Peril Occurrence <AsteriskSymbol/>
                                    </p>
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" style={{ marginTop: "18px", marginLeft: "10px" }}>
                                            {/* <input
                                                        type="date"
                                                        className="align4_data"
                                                        name="Date"
                                                        id="date"
                                                        placeholder=""
                                                        onChange={(e) => setDateField(e.target.value)}
                                                    /> */}
                                            <DatePicker
                                                selected={dateField}
                                                className="align4_dataPolicy"

                                                // style={{
                                                //     fontSize: '16px',
                                                //     color: '#333',
                                                //     backgroundColor: '#f5f5f5',
                                                //     padding: '10px',
                                                //     paddingLeft: '20px', // Added padding-left here
                                                //   }}
                                                onChange={hanldeDatechange}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select a date"
                                                maxDate={new Date()}
                                                highlightDates={new Date()}
                                                onKeyDown={(e) => e.preventDefault()}
                                            />
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" style={{ marginTop: "18px", marginLeft: "-10px" }}>
                                            <input
                                                type="time"
                                                className="align4_dataPolicy"
                                                name="Time"
                                                id="time"
                                                placeholder="Select Time"
                                                onChange={(e) => {
                                                    timeHandler(e.target.value)
                                                }}
                                                value={timeField}   
                                                onKeyDown={(e) => e.preventDefault()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                 <p className="data-align ms-0 mb-0">Damage Area & Units <AsteriskSymbol/></p>
                                 <div className="flex-Row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2" >
                                     <input
                                        type="text"
                                        className="align4_dataPolicy"
                                        id="damage-area"
                                        placeholder="Enter Area"
                                        value={reportedDamageArea}
                                        onChange={handleAreaChange}

                                    />
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-1" >
                                     <select
                                        className="align4_dataPolicy"
                                        id="damage-unit"
                                        value={reportedDamageAreaUnits}
                                        onChange={handleUnitChange}
                                        >
                                        <option value="">Select Unit</option>
                                        {unitOptions.map((u) => (
                                            <option key={u} value={u}>{u}</option>
                                        ))}
                                        </select>
                                    </div>
                                 </div>
                                 </div> */}
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 brief-descriptionPolicy">
                                    <p className="align3Policy">Brief Description of Loss</p>
                                    <textarea
                                        type="text"
                                        style={{
                                            width: "92%",
                                            height: "15px",
                                            marginLeft: "0",
                                            fontFamily: '"Roboto Flex", sans-serif',
                                            fontWeight: 500,
                                            fontSize: "15px",
                                            lineHeight: "18.75px",
                                            color: "rgba(0, 0, 0, 0.9)",
                                            padding: "1px",
                                            paddingBottom: "5px",
                                            border: "none",
                                            outline: "none",
                                            borderBottom: "1px solid #D2D2E4",
                                            marginTop: "5px",
                                            marginBottom: "5px",
                                            height: "28px", // Set the fixed height of the textarea
                                            maxHeight: "30px", // Set the maximum height of the textarea
                                            minHeight: "28px",
                                            overflow: "auto", // Add scrollbars when content exceeds the maximum height
                                            //resize: "" // Disable manual resizing
                                        }}
                                        className="align5_dataPolicy textarea_descriptionPolicy ms-3"
                                        name="Brief Description about Loss"
                                        id="Description"
                                        placeholder="Enter Description here"
                                        // defaultValue={""}
                                        onChange={(e) => {
                                            const maxLength = 500;
                                            const currentValue = e.target.value;
                                            if (currentValue.length > maxLength) {
                                                e.target.value = currentValue.slice(0, maxLength);
                                            }
                                            setClaimRequestData({ ...claimRequestData, 'claimDescriptionofLoss': e.target.value })
                                        }}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                                    <p className="align3Policy"> Attachment Type </p>
                                    <Select id="exampleInputPassword3" options={[{ label: "Farm Photo and Video", value: "farm_Photo_Video" }, { label: "Claim Form", value: "claim_form" }, { label: "Other", value: "other" }]}
                                        placeholder="Select Attachment Type"
                                        // isDisabled={!claimRequestData.product_name}
                                        value={claimRequestData.claimAttachmentType ? { label: claimRequestData.claimAttachmentType.label } : null}
                                        onChange={(data) => { 
                                            setClaimRequestData({ ...claimRequestData, claimAttachmentType: data });
                                            setAddedFiles([]) 
                                            if (data?.value === "farm_Photo_Video") {
                                                setvalidtype(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska'])
                                            }
                                            else if (data?.value === "claim_form") {
                                                setvalidtype(['text/csv', 'image/jpeg', 'image/png', 'text/plain', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/vnd.ms-excel', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/rtf', 'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/vnd.oasis.opendocument.spreadsheet'])
                                            }
                                            else if (data?.value === "other") {
                                                setvalidtype(['text/csv', 'image/jpeg', 'image/png', 'text/plain', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/vnd.ms-excel', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/rtf', 'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/vnd.oasis.opendocument.spreadsheet'])
                                            }
                                        }}
                                        styles={customStyles}
                                        isClearable
                                    />
                                </div>
                                {
                                    claimRequestData.claimAttachmentType &&  <FileUpload validtype={validtype} addedFiles={addedFiles} setAddedFiles={setAddedFiles} text={"Upload Proof of Loss"} roleDataCookie={roleDataCookie} doctypeName="claim" tran_id={raiseClaim.tran_id}/>
                                }
                                
                            </div>
                            {showAdditionalQuestion && additionalQuestions?.length && (
                                <div>
                                    <h3 id="new_claimPolicy" className="mb-4">Additional Information</h3>
                                    <div className="row mt-3 ms-0">
                                        {additionalQuestions.map(question => (
                                            (question?.questionId !== 2 || showAffectedDaysField) && (
                                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                    <p className="align3Policy ms-2">
                                                        {question?.questionText} <AsteriskSymbol />
                                                    </p>
                                                    {question?.questionId === 1 ? (
                                                        <div className="custom-date-picker">
                                                            <DatePicker                                                                
                                                                selected={
                                                                    (() => {
                                                                        const answer = additionalQA.find(ans => ans.qid === question.questionId)?.questionAnswer;
                                                                        return answer ? parse(answer, DATE_FORMAT.DD_MM_YYYY, new Date()) : null;
                                                                    })()
                                                                }
                                                                onChange={(date) => {
                                                                    setAdditionalQAValue(question.questionId, format(date, DATE_FORMAT.DD_MM_YYYY));
                                                                }}
                                                                className="align3_dataPolicy mt-2 ms-2 mb-2 d-block w-100"
                                                                dateFormat="dd-MM-yyyy"
                                                                classNamePrefix="w-100"
                                                                maxDate={new Date()}
                                                                highlightDates={new Date()}
                                                                onKeyDown={(e) => e.preventDefault()}
                                                            /></div>
                                                    ) : (
                                                        <input
                                                            key={question?.questionId}
                                                            className="align3_dataPolicy mt-2 ms-2 mb-2"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                setAdditionalQAValue(question.questionId, e.target.value)
                                                            }}
                                                            value={additionalQA.map(answers => answers.qid === question.questionId)?.questionAnswer || null}
                                                            maxLength={250}
                                                        />
                                                    )}
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className="buttonsPolicy" style={{ marginTop: "90px" }}>
                                {
                                    leavePageConfirmationModal && (
                                        <div id="custom-modal" className="custom-modal">
                                            <div className="custom-modal-content">
                                                <div className="custom-modal-header d-flex justify-content-between align-items-center">
                                                    <h4 className="ms-5 ps-5">Exit Confirmation</h4>
                                                    <span onClick={() => {
                                                        setLeavePageConfirmationModal(false)
                                                    }} className="custom-close" style={{marginTop: "-50px",marginRight: "-15px"}}>&times;</span>
                                                </div>
                                                <div className="custom-modal-body">
                                                    <p>Are you sure you want to leave this page?</p>
                                                </div>
                                                <div className="custom-modal-footer">
                                                    <button className="custom-btn custom-btn-secondary" onClick={() => {
                                                        setShowRadioSearch(false);
                                                        setRaiseclaim(null)
                                                        setOpenDropDown(false)
                                                        setSelectedIndex(null)
                                                    }}>Yes</button>
                                                    <button className="custom-btn custom-btn-primary" onClick={() => {
                                                        setLeavePageConfirmationModal(false)
                                                    }}>No</button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                <button className="backPolicy" disabled={claimDone} onClick={() => {
                                    //setShowRadioSearch(false);
                                    //setRaiseclaim(null);
                                    //setOpenDropDown(false);
                                    setLeavePageConfirmationModal(true)
                                }}>Back</button>
                                <button
                                    className="btn btn-success p-2 px-4 me-5 submitPolicy" 
                                    // disabled={!claimRequestData.claimPerilName || !claimRequestData.claimRiskName || !dateField || !timeField || claimDone||(claimRequestData.claimPerilName === "Animal Attack" && !selectedAnimal)||!claimIntimatedBy||isDisabled || !claimRequestData?.reportedDamageArea || !claimRequestData?.reportedDamageAreaUnits || !areAllAnswersFilled(additionalQA, showAffectedDaysField, showAdditionalQuestion)} 
                                    disabled={!claimRequestData.claimPerilName || !claimRequestData.claimRiskName || !dateField || !timeField || claimDone||(claimRequestData.claimPerilName === "Animal Attack" && !selectedAnimal)||!claimIntimatedBy||isDisabled || !areAllAnswersFilled(additionalQA, showAffectedDaysField, showAdditionalQuestion)} 
                                    onClick={() => onRaiseclaim()}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={modalShow}
                //onHide={() => setModalShow(false)}
            >
                {/* <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Modal heading
                    </Modal.Title>
                </Modal.Header> */}
                <Modal.Body>
                    <main>
                        <div className="vertical-alignment">
                            <div className="main-box text-center">
                                <a className="center">
                                    <img src="../kshemaImages/Star.png" alt="Success" width="132px" height="132px" className="center" />
                                </a>
                                <p className="claim_success">Claim Filed Successfully</p>
                                <p className="claim_description">We have successfully Filed your Claim,<br />
                                    This is Your Claim ID: <b>{claimID}</b></p>
                                <div className="hover">
                                    <p className="submit-box center" onClick={() => { setModalShow(false); setShowRadioSearch(false); setRaiseclaim(null); setSelectedIndex(null) }}>OK</p></div>
                            </div>
                        </div>
                    </main>
                </Modal.Body>
                {/* <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer> */}
            </Modal>
        </section>
    )
};

export default CreateClaim;